import React from "react";

function MyAccountModal({ onClose, user, onLogout }) {
  // --- Styles ---
  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 2000,
  };

  const modalStyle = {
    background: "#fff",
    borderRadius: "12px",
    width: "360px",
    padding: "30px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
  };

  const headingStyle = {
    fontSize: "24px",
    fontWeight: "600",
    marginBottom: "10px",
    color: "#333",
  };

  const infoStyle = {
    fontSize: "16px",
    color: "#333",
    marginBottom: "20px",
  };

  const buttonStyle = {
    width: "100%",
    borderRadius: "8px",
    backgroundColor: "#007bff",
    color: "#fff",
    fontSize: "16px",
    padding: "12px",
    border: "none",
    cursor: "pointer",
    marginBottom: "15px",
  };

  const closeButtonStyle = {
    width: "100%",
    borderRadius: "8px",
    backgroundColor: "#ddd",
    color: "#333",
    fontSize: "16px",
    padding: "12px",
    border: "none",
    cursor: "pointer",
    marginTop: "15px",
  };

  // --- Handlers ---
  const handleOverlayClick = () => {
    onClose();
  };

  const handleContainerClick = (e) => {
    // Prevent closing when clicking inside the modal content
    e.stopPropagation();
  };

  return (
    <div style={overlayStyle} onClick={handleOverlayClick}>
      <div style={modalStyle} onClick={handleContainerClick}>
        <h2 style={headingStyle}>My Account</h2>
        {user ? (
          <>
            <div style={infoStyle}>
              <p>
                <strong>Email:</strong> {user.email}
              </p>
              {user.name && (
                <p>
                  <strong>Name:</strong> {user.name}
                </p>
              )}
            </div>
          </>
        ) : (
          <p style={infoStyle}>No user information available.</p>
        )}
        <button style={buttonStyle} onClick={onLogout}>
          Logout
        </button>
        <button style={closeButtonStyle} onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}

export default MyAccountModal;
